import script from "./goRinSyo0059.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0059.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0059.vue?vue&type=style&index=0&id=64a10258&lang=scss"

const __exports__ = script;

export default __exports__